
// const API_BASE_URL = 'http://127.0.0.1:8000/api/v1/mayne';
const API_BASE_URL = 'https://quizzical-hugle.77-68-122-208.plesk.page/api/v1/mayne';

// const API_EMAIL_BASE_URL = 'http://127.0.0.1:8000/api/v1/email';
const API_EMAIL_BASE_URL = 'https://quizzical-hugle.77-68-122-208.plesk.page/api/v1/email';


const API_ENDPOINTS = {
  CUSTOMER_DETAILS: `${API_BASE_URL}/getCustomerDetails`,
  CUSTOMER_DELIVERY_ADDRESSES: `${API_BASE_URL}/getCustomerDeliveryAddresses`,
  PRODUCT_TYPES: `${API_BASE_URL}/getProductTypes`,
  PRODUCT_DETAILS: `${API_BASE_URL}/getProductDetails`,
  CHECK_STOCK: `${API_BASE_URL}/getStock`,
  ORDER_HISTORY: `${API_BASE_URL}/getOrderHistory`,
  SALES_ORDER: `${API_BASE_URL}/postSalesOrder`,
  GET_PRICE: `${API_BASE_URL}/getPrice`,
  STATEMENT: `${API_BASE_URL}/getStatement`,
  EMAIL_SUBMIT_MESSAGE: `${API_EMAIL_BASE_URL}/submitMessage`,
  EMAIL_FORGOT_PASSWORD: `${API_EMAIL_BASE_URL}/forgotPassword`,
  EMAIL_NOTIFY_STOCK: `${API_EMAIL_BASE_URL}/notifyStock`,
};


const APP_ROUTES = {
  ABOUT: '/about',
  SEARCH: '/search',
  PRODUCTS: '/products',
  PRODUCT: '/product',
  CART: '/cart',
  ORDER_CONFIRMATION: '/order-confirmation',
  ACCOUNT: '/account',
  ORDERS: '/account/orders',
  PAYMENTS: '/account/payments',
  STATEMENTS: '/account/statements',
  UPDATE_ACCOUNT_INFO: '/account/update-account-info',
  BILLING_DETAILS: '/account/billing-details',
  CONTACT: '/contact',
  TERMS: '/terms',
  COOKIES: '/cookies',
  PRIVACY: '/privacy',
  LOGIN: '/login',
  PRODUCT_CUT: '/product-cut',
  DASHBOARD: '/',
};

const CONSTANTS = {
  API_ENDPOINTS,
  APP_ROUTES,
};

export default CONSTANTS;
